import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import FileCopyIcon from '@mui/icons-material/FileCopy';

export const VendorsColumns = (handleCopy) => {
    return [
        {
            field: 'supplier_site_id',
            headerName: 'Supplier Site ID',
            width: 200,
            sortable: false,  // Disable sorting
            renderCell: (params) => {
                // console.log('Row data:', params.row);
                // console.log('Supplier Site ID:', params.row.vendor_id);
                
                return (
                    <Link 
                        to={{
                            pathname: `/dashboard/vendors/${params.row.vendor_id}`,
                            state: { rowData: params.row }
                        }}
                        style={{ 
                            textDecoration: 'none',
                            color: '#2196f3',
                            '&:hover': {
                                textDecoration: 'underline'
                            }
                        }}
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent row click event from triggering
                        }}
                    >
                        {params.row.supplier_site_id}
                    </Link>
                );
            }
        },
        
        {
            field: 'dept_code',
            headerName: 'Department Number',
            width: 180,
            sortable: true,  // Disable sorting
        },
        {
            field: 'vendor_name',
            headerName: 'Vendor Name',
            width: 200,
            sortable: true,  // Disable sorting
        },
        {
            field: 'commodity_code_name',
            headerName: 'Commodity Code',
            width: 150,
            sortable: false,  // Disable sorting
            renderCell: (params) => {
              return (
                <span>
                  {params.row.commodity_code} - {params.row.commodity_code_name}
                </span>
              );
            },
          },
          
        {
            field: 'fob_terms',
            headerName: 'FOB Terms',
            width: 150,
            sortable: false,  // Disable sorting
        },
        {
            field: 'chain',
            headerName: 'Chain',
            width: 120,
            sortable: false,  // Disable sorting
        },
        {
            field: 'area',
            headerName: 'Area',
            width: 100,
            sortable: false,  // Disable sorting
        },
        {
            field: 'brand_id',
            headerName: 'Brand ID',
            width: 120,
            sortable: false,  // Disable sorting
        },
        {
            field: 'brand_desc',
            headerName: 'Brand Description',
            width: 180,
            sortable: false,  // Disable sorting
        },
        {
            field: 'address',
            headerName: 'Address',
            width: 200,
            sortable: false,  // Disable sorting
        },
        {
            field: 'city',
            headerName: 'City',
            width: 150,
            sortable: false,  // Disable sorting
        },
        {
            field: 'zip',
            headerName: 'ZIP',
            width: 100,
            sortable: false,  // Disable sorting
        },
        // {
        //     field: 'status',
        //     headerName: 'Status',
        //     width: 120,
        //     sortable: false,  // Disable sorting
        // },
        {
            field: 'edit',
            headerName: 'Actions',
            width: 140,
            renderCell: (params) => (
                <>
                    <IconButton aria-label="copy" onClick={() => handleCopy(params.row)}>
                        <FileCopyIcon className='ml-5 delete-color' />
                    </IconButton>
                </>
            )
        }
    ];
};

export const VendorNotesColumns = (handleEdit,handleDelete) => {
    return [
        { 
            field: 'supplier_site_id', 
            headerName: 'Supplier Site Id', 
            width: 200 
        },
        { 
            field: 'dept_number', 
            headerName: 'Department', 
            width: 100 
        },
        { 
            field: 'note', 
            headerName: 'Note', 
            width: 300 
        },
        { 
            field: 'date_entered', 
            headerName: 'Date Entered', 
            width: 150 
        },
        { 
            field: 'last_updated', 
            headerName: 'Last Updated', 
            width: 150 
        },
        {
            field: 'edit',
            headerName: 'Actions',
            width: 140,
            renderCell: (params) => (
                <>
                    <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                        <ModeEditIcon className='ml-5 edit-color' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleDelete(params.row)}>
                        <DeleteIcon className='ml-5 delete-color' />
                    </IconButton>
                </>
            )
        }
    ];
};